import { BrowserModule } from '@angular/platform-browser'; 
import { FormsModule } from '@angular/forms';

// import { ImageUploadModule } from 'angular2-image-upload';
// import { UiSwitchModule } from 'ngx-ui-switch';
import { Http, HttpModule } from '@angular/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Route, Routes, RouterModule, PreloadingStrategy, PreloadAllModules } from '@angular/router';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { MyDatePickerModule } from 'mydatepicker';
import { MomentModule } from 'angular2-moment';
import { MainPipeModule } from '../app.pipes';
import { FocusModule } from 'angular2-focus';
import { MasonryModule } from 'angular2-masonry';
import { QRCodeModule } from 'angular2-qrcode';
import { FroalaEditorModule, FroalaViewModule } from 'angular2-froala-wysiwyg';

import { ViewComponent } from './view/view.component';
import { UserService } from '../services/user.service';
import { StoreService } from '../services/store.service';
import { SocialService } from '../services/social.service';
import { UserCliamsComponent } from './user-claims/user.claims.component';
import { UserItemsComponent } from './user-items/user.items.component';
import { CommunityComponent } from './user-community/user.community.component';
import { CharacterComponent } from './user-character/user.character.component';
import { DiscordComponent } from './user-discord/user.discord.component';
import { FriendsComponent } from './community/friends.component';
import { PeopleComponent } from './community/people.component';
import { UserComponent } from './user.component';
import { NetworkComponent } from './network/network.component';
import { SocialComponent } from './community/social.component';
import { ProfileComponent } from './community/user.profile.component';
import { FeaturesComponent } from './user-features/user.features.component';
import { NewUserComponent } from './create/newuser.component';

export const UserRoutes = [
  { path: 'network',                component: NetworkComponent, data: { title: 'Network - Identity RPG' } },
  { path: 'id/:id',                 component: ViewComponent, data: { title: 'User - Identity RPG' } },
  { path: 'profile/:id',            component: ViewComponent, data: { title: 'User Profile - Identity RPG' } },
  { path: 'account/new',            component: NewUserComponent, data: { title: 'New Identity - Identity RPG' } },
  { path: 'view',                   component: UserComponent, data: { title: 'My Account - Identity RPG' } },
  { path: 'account',                component: UserComponent, data: { title: 'My Account - Identity RPG' } },
  { path: 'account/view',           component: UserComponent, data: { title: 'My Account - Identity RPG' } },
  { path: 'account/view/:path',     component: UserComponent, data: { title: 'My Account - Identity RPG' } },
  { path: 'account/people',         component: PeopleComponent, data: { title: 'Listing Identities - Identity RPG' } },
  { path: 'account/claims',         component: UserCliamsComponent, data: { title: 'Claims - My Account - Identity RPG' } },
  { path: 'account/character',      component: CharacterComponent, data: { title: 'Character Customizer - Identity RPG' } }, 
];

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [
    UserComponent,
    CommunityComponent,
    FriendsComponent,
    UserCliamsComponent,
    ProfileComponent,
    NetworkComponent,
    NewUserComponent,
    UserItemsComponent,
    CharacterComponent,
    DiscordComponent,
    PeopleComponent,
    ViewComponent,
    SocialComponent,
    FeaturesComponent,
  ],
  providers: [
    UserService,
    StoreService,
    SocialService
  ],
  imports: [
    MainPipeModule,
    BrowserModule,
    FormsModule,
    CommonModule,
    MasonryModule,
    QRCodeModule,
    MomentModule,
    // UiSwitchModule,
    ReCaptchaModule,
    MyDatePickerModule,
    FocusModule.forRoot(),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    // ImageUploadModule.forRoot(),
  	RouterModule.forChild(UserRoutes)
  ],
  exports: [ 
    CommonModule,
    RouterModule
  ]
})
export class UserModule {}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user.module.ts